<template>
    <div class="index">

        <topNav></topNav>

        <div v-if="currentType && currentType.typeCode === '000002'" class="top"
            :style="{ 'background-image': 'url(static/news_top_bg.png)', 'position': 'relative', 'width': '100%', 'height': '600px', 'background-size': 'auto 100%', 'background-position': '0px 0px' }">
            <div class="about_us_nav"
                style="display:flex;text-align:center;height:35px;background:url(static/year_bg.png) no-repeat;background-size:100% 100%;color:#fff;font-weight:700;line-height:35px;">
                <div style="margin-left:30%;cursor:pointer" @click="goYear(1)"><img src="static/year_go_big.png"
                        style="width:20px;" /></div>
                <div style="margin-left:6%;">{{ currentYear }}</div>
                <div style="margin-left:5%;cursor:pointer" @click="goYear(0)"><img src="static/year_go_small.png"
                        style="width:20px;" /></div>
            </div>
        </div>
        <div v-else-if="currentType && currentType.typeCode === '000006'" class="top"
            :style="{ 'background-image': 'url(static/contact_us_top_bg.png)', 'position': 'relative', 'width': '100%', 'height': '600px', 'background-size': 'auto 100%', 'background-position': '0px 0px' }">
            
        </div>
        <div v-else-if="currentType && currentSubType" class="top"
            :style="{ 'background-image': 'url(' + (aboutUsNav[currentType.subMap.findIndex(s=>s.typeCode===currentSubType.typeCode)] ? aboutUsNav[currentType.subMap.findIndex(s=>s.typeCode===currentSubType.typeCode)].bg : '') + ')', 'position': 'relative', 'width': '100%', 'height': '600px', 'background-size': 'auto 100%', 'background-position': '0px 0px' }">
            <ul v-if="currentType" class="about_us_nav">
                <li v-for="(sub) in currentType.subMap" :key="sub.typeCode" @click="updateType(sub), articleListByPage()"
                    :class="[sub.typeCode == currentSubType.typeCode  ? 'itemActive' : 'itemNoActive']">{{ isEnglish && sub.eName ? sub.eName :
                        sub.typeName }}</li>
            </ul>
        </div>

        <div style="position:absolute;left:20px;top:150px;width:68%;text-align:left;" class="brief_1 Impact">Green Supply
            Chain Action in China’s Real Estate Industry</div>
        <div style="position:absolute;left:20px;top:260px;width:55%;text-align:left;" class="brief_1 Impact"
            v-if="$store.state.language === 'cn'">中国房地产行业<br />绿色供应链行动</div>

        <pageLocation :currentLocation="curPage"></pageLocation>

        <div v-if="currentType && currentType.typeCode === '000001'"
            style="width:100%;min-height:900px;margin:120px auto 0px auto;">
            <div v-if="currentSubType" style="width:80%;margin:0 auto;color:#5a6f18" class="brief_1 Impact">
                {{ currentSubType.eName }}
            </div>
            <div v-if="$store.state.language === 'cn' && currentSubType" style="width:80%;margin:0 auto;color:#92ab26"
                class="brief_1 Impact">{{ currentSubType.typeName }}</div>
            <div style="width:80%;margin:20px auto">
                <div style="text-align:left;" class="article-content"  v-html="curArticleContent.content"></div>
            </div>
        </div>
        <div v-else
            style="width:100%;height:auto;margin:120px auto 0px auto;">
            <template v-if="currentType && currentType.typeCode === '000002'">
                <div style="width:80%;margin:0 auto"><img src='static/news.png'
                    style="width:130px;display:block;margin:0 auto;"></div>
            <div style="width:80%;margin:0 auto" v-if="$store.state.language === 'cn'"><img
                    src='static/news_infomation_ch_text.png' style="width:100px;display:block;margin:10px auto auto auto;">
            </div>
            </template>
            <template v-else>
                <div v-if="currentSubType" style="width:80%;margin:0 auto;color:#5a6f18" class="brief_1 Impact">
                {{ currentSubType.eName }}
            </div>
            <div v-if="$store.state.language === 'cn' && currentSubType" style="width:80%;margin:0 auto;color:#92ab26"
                class="brief_1 Impact">{{ currentSubType.typeName }}</div>
            </template>
            

            <div v-if="articleList.length > 1" style="width:80%;margin:20px auto;border-top:1px solid #628838">
                <!--新闻列表-->
                <ul class="newsItem" v-for="(newItem, index) in articleList" :key="index">
                    <li style="float:left;">

                        <img v-if="newItem.imgUrl" :src="newItem.imgUrl" class="facePic" />
                        <img v-else src='static/bottom-logo.png' class="facePic" />


                    </li>
                    <li style="float:left;margin-top:10px;">
                        <div
                            style="text-align:center;font-weight:700;font-size:20px;color:#57802b;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana'">
                            {{ newItem.createdat.substring(5, 10) }}</div>
                        <div style="text-align:center;">{{ newItem.createdat.substring(0, 4) }}</div>
                        <div style="text-align:center;">{{ newItem.authorName }}</div>
                    </li>
                    <li @click="showOrHideDetail(newItem.articleId, $event, newItem.channelId)"
                        style="margin-top:10px;border:1px solid #8fa926;border-radius:15px;color:#8fa926;width:26px;height:26px;line-height:26px;font-size:26px;">+</li>
                    <li style="text-align:left;margin-top:10px;margin-bottom:10px;">{{ newItem.articleName }}</li>
                    <div style="width:100%;height:2px;clear:both;"></div>
                    <!-- <li class="detailContent" :id="newItem.articleId" style="width:95%;display:none;text-align:left;" v-html="newItem.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile')"></li> -->
                    <li class="fileContent" :id="'file-'+newItem.articleId" style="width:95%;display:none;text-align:left;">
                        <!--应该是附件-->
                    </li>
                    <li class="detailContent" :id="'content-'+newItem.articleId" style="width:95%;display:none;text-align:left;"
                        v-html="newItem.content"></li>

                </ul>

            </div>
            <div v-else style="width:80%;margin:20px auto">
                <el-button  style="background-color: #89a128;color: white;" v-if="currentSubType && currentSubType.typeName === '环境合规性供应商白名单检索'" @click="openUrl">环境合规性供应商白名单检索</el-button>
                <el-button  style="background-color: #89a128;color: white;" v-if="currentSubType && currentSubType.typeName === '白、绿名单申报'" @click="openUrl">白、绿名单申报</el-button>
                <el-button  style="background-color: #89a128;color: white;" v-if="currentSubType && currentSubType.typeName === '白名单申报'" @click="openUrl">白名单申报</el-button>
                <el-button  style="background-color: #89a128;color: white;" v-if="currentSubType && currentSubType.typeName === '供应商白、绿名单'" @click="openUrl">供应商白、绿名单</el-button>
                <div style="text-align:left;" class="article-content" v-if="!currentSubType || currentSubType.typeName !== '供应商白、绿名单'" v-html="curArticleContent.content"></div>
            </div>
        </div>



        <img src="static/about_us_bottom_img01.png" v-if="curAbout == 0"
            style="width:100%;display:block;margin-bottom:-2px;" />
        <!--底部组件-->
        <friendLinkAndFooter></friendLinkAndFooter>

    </div>
</template>
  
  
<script>
  import { articleListByPage, articleDetail } from "@/api";
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  import friendLinkAndFooter from '@/components/friendLinkAndFooter'
  import topNav from '@/components/topNav'
  import pageLocation from '@/components/pageLocation'
import { mapActions, mapGetters } from 'vuex';
  export default {
    name: 'aboutUs',
    components: {
      topNav, friendLinkAndFooter, pageLocation
    },
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        showNav: false,
        pages: 1,
        //关于我们当前的页签
        curPage: '关于绿链',
        curAbout: 0,
        curArticleCode: 'WZNR201610311925050031',
        curArticleContent: {},
        articleList: [],
        currentYear:'2024',
      yearList:[
      {'year':'2024'},
      {'year':'2023'},
      {'year':'2022'},
                 {'year':'2021'},
                 {'year':'2020'},
                 {'year':'2019'},
                 {'year':'2018'},
                 {'year':'2017'},
                 {'year':'2016'}
      ],
        aboutUsNav: [
          { 'name': '关于绿链', 'articleCode': 'WZNR201610311925050031', 'catCode': '', 'bg': 'static/about_us_to_bg.png' },
          { 'name': '行动宣言', 'articleCode': 'WZNR201610311925050032', 'catCode': '000001|000037', 'articleList': [], 'bg': 'static/about_us_xdxy_top_bg.png' },
          { 'name': '组织结构', 'articleCode': 'WZNR201610311925050033', 'catCode': '', 'bg': 'static/about_us_top_zzjg_bg.png' },
          { 'name': '企业名录', 'articleCode': 'WZNR201610311925050034', 'catCode': '', 'bg': 'static/about_us_qyml_bg.png' }
          // {'name':'发展历程','articleCode':'000000008','catCode':'','bg':'static/about_us_to_bg.png'}
        ]
      }
    },
    computed: {
    ...mapGetters(['currentType', 'currentSubType', 'isEnglish', 'typeLists'])
  },
    methods: {
        ...mapActions(['changeSubType','changeType']),
      showAbout(n) {
        this.articleListByPage();
      },
      updateType(sub) {
        this.changeSubType(sub);
        if (this.$route.path.indexOf('/content/') === 0) {
          console.log(sub.eName.replace(' ', ''))
          this.$router.replace({ path: `/content/${this.currentType.eName.replaceAll(' ','')}/${sub.eName?sub.eName.replaceAll(' ', ''):''}` });
        }
        else {
          this.$router.replace({ path: `/${this.$route.path.split('/')[1]}/${sub.eName ? sub.eName.replaceAll(' ', ''):''}` });
        }
      },
      articleDetail(articleCode) {
        const params = {
          articleId: articleCode,
          isEn: this.$store.state.language === 'en' ? 1 : 0
        }
        articleDetail(params).then((res) => {
          // console.log(res);
          this.curArticleContent = res.data
          let articleFileList = res.data.nodeVoList;
          if(articleFileList){
            var fileHtml="";
            for(var i=0;i<articleFileList.length;i++){
                 fileHtml+="附件"+(i+1)+"：<a href='http://gsc.see.org.cn/file/file/api/download?nodeId="+articleFileList[i].noteId+"' >"+articleFileList[i].nodeName+"</a><br/>"
            }
            if (document.getElementById('file-' + articleCode)) {
                document.getElementById('file-'+articleCode).innerHTML = fileHtml;
            } 
          }else{
            document.getElementById('file-' + articleCode)&& document.getElementById('file-'+articleCode).setAttribute("style", "display:none")
          }
            setTimeout(() => {
              var o=document.querySelectorAll('.detailContent img');
                if(o){
                  for(var i=0;i<o.length;i++){
                    o[i].setAttribute("style","width:100%")
                  }
                }
            }, 2000);
        })
  
      },
      openUrl(url) {
        if (this.currentSubType.typeName === '环境合规性供应商白名单检索') {
                // window.open('https://www.ipe.org.cn/IndustryRecord/Regulatory_Green.aspx', '_blank');
                window.open('https://out.ipe.org.cn/IndustryRecord/Regulatory_Green.aspx', '_blank');
                return;
            }
            else if (this.currentSubType.typeName === '白、绿名单申报') {
                window.open('https://greenlist.see.org.cn/user/UserData.aspx', '_blank');
                return;
            }
            else if (this.currentSubType.typeName === '白名单申报') {
                window.open('http://lxi.me/bg22z', '_blank');
                return;
            }
            else if (this.currentSubType.typeName === '供应商白、绿名单') {
                window.open('https://greenlist.see.org.cn/Industry/GreenList.aspx?cmd=search&istenday=0&Page=1', '_blank');
                return;
            }
      },
  
      articleListByPage(loading = false) {
        if (this.currentSubType && !loading) {
            if (this.currentSubType.typeName === '环境合规性供应商白名单检索') {
                this.articleList = [];
                this.article = null;
                this.curArticleContent = {};
                // window.open('https://www.ipe.org.cn/IndustryRecord/Regulatory_Green.aspx', '_blank');
                return;
            }
            else if (this.currentSubType.typeName === '白、绿名单申报') {
                this.articleList = [];
                this.article = null;
                this.curArticleContent = {};
                // window.open('https://greenlist.see.org.cn/user/UserData.aspx', '_blank');
                return;
            }
            else if (this.currentSubType.typeName === '白名单申报') {
                this.articleList = [];
                this.article = null;
                this.curArticleContent = {};
                // window.open('http://lxi.me/bg22z', '_blank');
                return;
            }
            else if (this.currentSubType.typeName === '供应商绿名单') {
                this.articleList = [];
                this.article = null;
                this.curArticleContent = {};
                return;
                // window.open('https://greenlist.see.org.cn/Industry/GreenList.aspx?cmd=search&istenday=0&Page=1', '_blank');
                // return;
            }
        }

        var that = this
        // console.log(this.dateY,' =====____');
        const params = {
          page: that.pages,
          catCode: this.currentSubType ? `${this.currentType.typeCode}%7C${this.currentSubType.typeCode}` : this.currentType.typeCode,
          limit: 99999,
          year: this.currentType.typeCode === '000002' ? this.currentYear: '',
          isEn: this.$store.state.language === 'en' ? 1 : 0
        };
        articleListByPage(params).then(res => {
          console.log(res.data);
          that.articleList = res.data.list;
          if (that.articleList.length > 0) {
            that.articleDetail(that.articleList[0].articleId)
          }
        });
      },
      goYear(n){
        if(n==1){
          this.currentYear++;
        }else{
          this.currentYear--;
        }
          this.articleListByPage()
        },
        showOrHideDetail(articleCode,event,channelId){
            if(event.target.innerHTML=='+'){
                this.articleDetail(articleCode);
                document.getElementById('file-'+articleCode).setAttribute("style","display:block")
                document.getElementById('content-'+articleCode).setAttribute("style","display:block")
                event.target.innerHTML='-';
                    setTimeout(() => {
                    var o=document.querySelectorAll('.detailContent img');
                
                        if(o){
                        for(var i=0;i<o.length;i++){
                            o[i].setAttribute("style","width:100%")
                        }
                        }
                    
                    }, 2000);
            }else{
                document.getElementById('file-'+articleCode).setAttribute("style","display:none")
                document.getElementById('content-'+articleCode).setAttribute("style","display:none")
                event.target.innerHTML='+';
            }

    },

    },
    watch: {
        '$route'(to, from) {
            const type = this.currentType;
            if (this.currentSubType) {
                this.curPage = this.$store.state.language === 'en' && this.currentSubType.eName? this.currentSubType.eName : this.currentSubType.typeName;
            }
            else {
                this.changeSubType(type.subMap[0]);
                this.curPage = this.$store.state.language === 'en' && type.eName? type.eName : type.typeName;
            }
            // this.articleListByPage(true)
        }
    },
    mounted() {
        let type = null;
        if (!this.currentType && this.typeLists.length > 0 && this.$route.params.typeName) {
          type = this.typeLists.find(v=>v.eName && v.eName.replaceAll(' ', '') === this.$route.params.typeName);
          this.changeType(type);
        }
        console.log('---type:', type)
        if (!this.currentSubType && this.typeLists.length > 0 && this.$route.params.subTypeName && type) {
          const sub = type.subMap.find(v=>v.eName && v.eName.replaceAll(' ', '') ===  this.$route.params.subTypeName);
          console.log('sub:', sub);
          this.changeSubType(sub);
          this.curPage = this.$store.state.language === 'en' && this.currentSubType.eName? this.currentSubType.eName : this.currentSubType.typeName;
        }
        

      if (!this.currentSubType && this.currentType.subMap.length > 0) {
        this.changeSubType(this.currentType.subMap[0]);
        this.curPage = this.$store.state.language === 'en' && this.currentSubType.eName? this.currentSubType.eName : this.currentSubType.typeName;
      }
      
      if (!this.currentSubType){
        this.curPage = this.$store.state.language === 'en' && type.eName? type.eName : type.typeName;
      }


      this.$nextTick(()=>{
        this.articleListByPage(true)
      });
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// /* @import '@/assets/css/content.css'; */
// @import '../assets/css/content.css';

// img {
//   width: 100% !important;
// }
.articleContentStyle /deep/ * {
    img {
        width: 100% !important;
        height: auto !important;
    }
}
.detailContent img {
    width: 100%;
}
.brief_1 {
    font-size: 20px;
    font-weight: 900;
    color: #fff;
}
.newsItem{border-bottom:1px solid #628838;overflow:hidden;margin-top:10px;}

.newsItem .facePic{width:150px;}
.Impact {
    font-family: Impact, 微软雅黑;
}

.about_us_nav {
    margin: 0px;
    padding: 0px;
    display: flex;
    position: absolute;
    bottom: -20px;
    width: 90%;
    left: 5%;
    box-shadow: #ebebeb 5px 5px 5px 5px;
}

.about_us_nav li {
    margin: 0px;
    padding: 10px 0;
    width: 25%;
    text-align: center;
    // height: 35px;
    // line-height: 35px;
    border-right: 1px solid #89a128;
    font-size: 12px;
}

.show {
    display: block;
}

.item {
    width: 100%;
    height: 50px;
    margin: 0px;
    display: block;
}

.itemActive {
    background: #89a128;
    color: #fff;
}

.itemNoActive {
    background: #fff;
    color: #89a128;
}

.hidden {
    display: none;
}

.index {
    margin: 0px;
    padding: 0px;
    width: 100%;
    min-height: 960px;
}

.top {
    position: relative;
    width: 100%;
    height: 600px;
    background-size: auto 100%;
    background-position: 0px 0px;
}

.navBox {
    width: 150px;
}

.navBox li {
    height: 30px;
}

.navBox li a {
    color: #fff;
    text-align: right;
    display: block;
    width: 100%;
    text-decoration: none;
}

.declarationItem {
    width: 45%;
    float: left;
    overflow: hidden;
    margin: 10px 2% 10px 2%;
    padding: 0px;
    height: 260px;
}
.article-content /deep/ img {
    width: 100%;
}
.declarationItem li {
    margin: 0px;
    padding: 0px;
}

h1,
h2 {
    font-weight: normal;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}</style>
  


// WEBPACK FOOTER //
// src/components/content.vue